module.exports = __webpack_public_path__ + "static/33F324_A_0-614a0434d7129c15d840845576ed32d0.woff2";